import * as React from 'react';
import bindAllOfThis from "src/utils/BindThisHelper";
import PhaserGameComponent from 'src/games/shared/phaserHelpers/PhaserGameComponent';
import { GameIntroScene } from 'src/games/SpacePortGame/scenes/GameIntro';

interface PhaserSpacePortGameProps {
    onComplete: () => void;
}

interface PhaserSpacePortGameState {
}

const gameConfig: GameConfig = {
    title: "Space Port Game",
    version: "0.2",
    backgroundColor: "#000000",
};

class PhaserSpacePortGame extends React.Component<PhaserSpacePortGameProps, PhaserSpacePortGameState> {
    private game: Phaser.Game;
    constructor(props: PhaserSpacePortGameProps) {
        super(props);
        bindAllOfThis(this, PhaserSpacePortGame.prototype);
    }

    render() {
        return (<div>
            <PhaserGameComponent scenes={GameIntroScene} config={gameConfig} onComplete={this.props.onComplete} />
        </div>);
    }
}

export default PhaserSpacePortGame;



// WEBPACK FOOTER //
// ./src/games/SpacePortGame/Main.tsx